
import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";

type MyAccordionProps = {
    header: string;
    body: string;
}

const SimpleAccordion  = (props: MyAccordionProps) => {
    return <>
        <Accordion sx={{ width: "100%", bgcolor: "#1f1f1f", color: "#fff" }}>
            <AccordionSummary expandIcon={<ExpandMore />} >
                <Typography variant={"subtitle1"} sx={{ fontWeight: 'bold', color: "#fff" }}>
                    {props.header}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ bgcolor: "#1f1f1f" }}>
                <Typography variant={"body2"} sx={{ color: "#fff" }}>
                    {props.body}
                </Typography>
            </AccordionDetails>
        </Accordion>
    </>
}

export default SimpleAccordion;